export default __webpack_public_path__ + "static/media/go-back.2150bcca.svg";